/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Settings_EnabledInputs */

const vi_smartlab_settings_enabled = /** @type {(inputs: Smartlab_Settings_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật tích hợp`)
};

/**

* @param {Smartlab_Settings_EnabledInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_settings_enabled = /** @type {((inputs?: Smartlab_Settings_EnabledInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Settings_EnabledInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_settings_enabled(inputs)
});